import React from 'react';
import { NextUI } from '@/components/NextUI';
import Button from '@/components/NextUI/Button';
import { useTranslations } from 'next-intl';

interface MakeSureData {
  title?: string;
  description?: string;
  onConfirm: () => void | Promise<void>;
  close: () => void;
}

const MakeSure = ({ data }: { data: MakeSureData }) => {
  const t = useTranslations('modals.make_sure');

  const title = data?.title ?? t('default_title');
  const description = data?.description ?? t('default_description');

  const handleConfirm = async () => {
    await data.onConfirm();
    data.close();
  };

  return (
    <NextUI.Modal
      className="max-w-[500px]"
      classNames={{ content: 'py-8 !px-4 md:!px-8' }}
      defaultOpen={true}
      name={'MakeSureModal'}
    >
      <h2 className="h5 font-semibold text-start text-dark">{title}</h2>

      <p className="text-gray-dark text-sm mt-6">{description}</p>

      <div className="flex justify-end gap-4 mt-8">
        <Button variant="outline" className="w-[160px]" onClick={data.close}>
          {t('buttons.close')}
        </Button>

        <Button className="w-[160px]" onClick={handleConfirm}>
          {t('buttons.approve')}
        </Button>
      </div>
    </NextUI.Modal>
  );
};

export default MakeSure;
